import { useTranslation } from "react-i18next"
import ConfirmationDialog from "../../molecules/ConfirmationDialog/ConfirmationDialog"

interface SubscriptionGiftConfirmationDialogProps {
    faqText: string
    isFAQDialogOpen: boolean
    onFAQDialogConfirm: (value: boolean) => void
    tncText: string
    isTNCDialogOpen: boolean
    onTNCDialogConfirm: (value: boolean) => void
}

const SubscriptionGiftConfirmationDialog = (props: SubscriptionGiftConfirmationDialogProps) => {
    const { faqText, isFAQDialogOpen, onFAQDialogConfirm, tncText, isTNCDialogOpen, onTNCDialogConfirm} = props
    const { t } = useTranslation()

    return <>
        <ConfirmationDialog
            confirmationTitle={t(`simple_faq_title`)}
            confirmationText={faqText}
            buttonText={t(`close`)}
            defaultOpen={isFAQDialogOpen}
            onConfirm={()=> onFAQDialogConfirm(false)}
            acknowledgeOnly
        />
        <ConfirmationDialog
            confirmationTitle={t(`deal_terms_and_conditions`)}
            confirmationText={tncText}
            buttonText={t(`close`)}
            defaultOpen={isTNCDialogOpen}
            onConfirm={()=> onTNCDialogConfirm(false)}
            acknowledgeOnly
        />
    </>
}

export default SubscriptionGiftConfirmationDialog